import { useState } from 'react';
import { DetailsTab } from './DetailsTab/DetailsTab';
import { HorizontalTabList } from './HorizontalTabList/HorizontalTabList';
import { TicketDetailsFooter } from './TicketDetailsFooter/TicketDetailsFooter';
import {
  SelectTabData,
  TabValue,
  SelectTabEvent,
} from '@fluentui/react-components';
import { NotesTab } from './NotesTab/NotesTab';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';

export const TicketDetailsMobile = () => {
  const [selectedPane, setSelectedPane] = useState<TabValue>('details');
  const { handleShowErrorMessage } = useServiceDeskContext();

  const onTabChange = (event: SelectTabEvent, data: SelectTabData) => {
    setSelectedPane(data.value);
    if (selectedPane === 'details') {
      handleShowErrorMessage(false, '');
    }
  };
  return (
    <>
      <HorizontalTabList
        selectedValue={selectedPane}
        handleTabChange={onTabChange}
      />
      {selectedPane === 'details' && (
        <>
          <DetailsTab />
          <TicketDetailsFooter />
        </>
      )}
      {selectedPane === 'notes' && <NotesTab />}
    </>
  );
};
